import React, { useEffect } from 'react';

const HomeSEO: React.FC = () => {
  useEffect(() => {
    // Update document title and metadata for better SEO
    document.title = "TimeCapsule - Preserve Memories For The Future";
    
    // Update meta description if exists
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute("content", 
        "Create digital time capsules to preserve and share your precious memories across time. TimeCapsule lets you lock photos and moments until a future date.");
    }

    // Add structured data for SEO
    const structuredData = {
      "@context": "https://schema.org",
      "@type": "WebApplication",
      "name": "TimeCapsule",
      "applicationCategory": "Photography",
      "operatingSystem": "Web, iOS, Android",
      "description": "Create digital time capsules to preserve and share your precious memories across time.",
      "author": {
        "@type": "Organization",
        "name": "TimeCapsule App",
        "logo": {
          "@type": "ImageObject",
          "url": "https://capsuletime.co/favicon-32x32.png"
        },
        "url": "https://capsuletime.co"
      },
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "USD",
        "availability": "https://schema.org/InStock"
      },
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "ratingCount": "125",
        "bestRating": "5",
        "worstRating": "1"
      }
    };

    // Add structured data to page
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.textContent = JSON.stringify(structuredData);
    document.head.appendChild(script);

    // Clean up function
    return () => {
      if (script.parentNode) {
        document.head.removeChild(script);
      }
    };
  }, []);

  return null;
};

export default HomeSEO;
